module.exports = __webpack_public_path__ + "static/media/kc.705986bb.png";